import apiService from './apiService';

export const dataQualityService = {
    // Dashboard
    dashboard: {
        get: () => apiService.get('/data-quality/dashboard'),
    },

    // Duplicate Detection
    duplicates: {
        scan: (page = 0, size = 10) => apiService.get('/data-quality/duplicates/scan', { page, size }),
        getForClient: (clientId) => apiService.get(`/data-quality/duplicates/client/${clientId}`),
    },

    // Merge
    merge: {
        preview: (data) => apiService.post('/data-quality/merge/preview', data),
        execute: (data) => apiService.post('/data-quality/merge/execute', data),
        history: (page = 0, size = 10) => apiService.get('/data-quality/merge/history', { page, size }),
    },

    // Profile Completeness
    completeness: {
        getForClient: (clientId, companyId) =>
            apiService.get(`/data-quality/completeness/client/${clientId}`, companyId ? { companyId } : {}),
        getRetail: (page = 0, size = 10, companyId) =>
            apiService.get('/data-quality/completeness/retail', { page, size, ...(companyId ? { companyId } : {}) }),
        getCorporate: (page = 0, size = 10, companyId) =>
            apiService.get('/data-quality/completeness/corporate', { page, size, ...(companyId ? { companyId } : {}) }),
        getStats: (clientType, companyId) =>
            apiService.get('/data-quality/completeness/stats', { clientType, ...(companyId ? { companyId } : {}) }),
    },

    // Completeness Rules
    rules: {
        getAll: (clientType, companyId) =>
            apiService.get('/data-quality/completeness/rules', { clientType, ...(companyId ? { companyId } : {}) }),
        create: (data) => apiService.post('/data-quality/completeness/rules', data),
        update: (id, data) => apiService.put(`/data-quality/completeness/rules/${id}`, data),
        delete: (id) => apiService.delete(`/data-quality/completeness/rules/${id}`),
        seedDefaults: () => apiService.post('/data-quality/completeness/rules/seed-defaults'),
    },

    // Health
    health: {
        kyc: (companyId) =>
            apiService.get('/data-quality/health/kyc', companyId ? { companyId } : {}),
        clients: () => apiService.get('/data-quality/health/clients'),
    },

    // Issues
    issues: {
        getAll: (page = 0, size = 10, issueType) =>
            apiService.get('/data-quality/issues', { page, size, ...(issueType ? { issueType } : {}) }),
        getForClient: (clientId) => apiService.get(`/data-quality/issues/client/${clientId}`),
    },

    // Cleanup Tools
    cleanup: {
        standardizePhone: (clientId, countryCode = '+254') =>
            apiService.post(`/data-quality/cleanup/standardize-phone/${clientId}?countryCode=${encodeURIComponent(countryCode)}`),
        standardizeEmail: (clientId) =>
            apiService.post(`/data-quality/cleanup/standardize-email/${clientId}`),
        standardizeName: (clientId) =>
            apiService.post(`/data-quality/cleanup/standardize-name/${clientId}`),
        correctField: (clientId, data) =>
            apiService.post(`/data-quality/cleanup/correct-field/${clientId}`, data),
        bulk: (data) => apiService.post('/data-quality/cleanup/bulk', data),
        missingField: (fieldName, clientType, page = 0, size = 10) =>
            apiService.get('/data-quality/cleanup/missing-field', {
                fieldName, page, size,
                ...(clientType ? { clientType } : {})
            }),
        stale: (monthsThreshold = 6, page = 0, size = 10) =>
            apiService.get('/data-quality/cleanup/stale', { monthsThreshold, page, size }),
    },
};
